export default "__VITE_ASSET__HQ0DUzRJ__"